import axios, { AxiosResponse } from 'axios';
import { action } from 'typesafe-actions';
import { apiUrl } from './../../index';
import { alertError, alertSuccess } from './../alert/actions';
import { User } from './../user/types';
import { UserActionTypes } from './types';

export const getUserAutoSuggestions = (searchString: string, userType?: string) => {
  const fetchRequest = () => action(UserActionTypes.FETCH_REQUEST_AUTOCOMPLETE);
  const fetchSuccess = (data: User[]) => action(UserActionTypes.FETCH_SUCCESS_AUTOCOMPLETE, data);
  const fetchError = (error: Error) => action(UserActionTypes.FETCH_ERROR_AUTOCOMPLETE, error);

  interface Response {
    users: User[];
  }
  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/user/autocomplete', {
        params: {
          searchString,
          type: userType
        }
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('DATA', res.data.users);
        dispatch(fetchSuccess(res.data.users));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const updateUser = (user: User) => {
  const fetchRequest = () => action(UserActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: User) => action(UserActionTypes.UPDATE_USER_SUCCESSFULL, data);
  const fetchError = (error: Error) => action(UserActionTypes.FETCH_ERROR, error);

  interface Response {
    user: User;
  }
  return (dispatch: any) => {
    dispatch(fetchRequest());

    return axios
      .put(apiUrl + '/user/', { user })
      .then((res: AxiosResponse<Response>) => {
        dispatch(fetchSuccess(res.data.user));
        dispatch(alertSuccess('User gespeichert!'));

        return Promise.resolve();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));

        return Promise.reject();
      });
  };
};

export const createUser = (user: User, clearForm: any) => {
  const fetchRequest = () => action(UserActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: User) => action(UserActionTypes.UPDATE_USER_SUCCESSFULL, data);
  const fetchError = (error: Error) => action(UserActionTypes.FETCH_ERROR, error);

  interface Response {
    user: User;
  }
  return (dispatch: any) => {
    dispatch(fetchRequest());

    console.log(user);
    const route = apiUrl + '/user/create/' + user.role.name;

    return axios
      .post(route, { ...user })
      .then((res: AxiosResponse<Response>) => {
        dispatch(fetchSuccess(res.data.user));
        dispatch(alertSuccess('User gespeichert!'));
        clearForm();
        return Promise.resolve();
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));

        return Promise.reject();
      });
  };
};

export const getUsers = (url: string, params: any) => {
  const fetchRequest = () => action(UserActionTypes.FETCH_REQUEST);
  const fetchSuccess = (data: User[]) => action(UserActionTypes.FETCH_SUCCESS, data);
  const fetchError = (error: Error) => action(UserActionTypes.FETCH_ERROR, error);

  interface Response {
    users: User[];
  }
  return (dispatch: any) => {
    dispatch(fetchRequest());

    axios
      .get(apiUrl + '/user' + url, {
        params
      })
      .then((res: AxiosResponse<Response>) => {
        console.log('DATA', res.data.users);
        dispatch(fetchSuccess(res.data.users));
      })
      .catch(err => {
        dispatch(fetchError(err));
        dispatch(alertError(err));
      });
  };
};

export const clearSuggestions = () => {
  return (dispatch: any) => {
    dispatch(action(UserActionTypes.CLEAR_SUGGESTIONS));
  };
};



// WEBPACK FOOTER //
// ./src/store/user/action.ts